// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_ni-0";